<template>
  <div class="video-player">
    <iframe
      v-if="embedUrl"
      :src="embedUrl"
      frameBorder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
      width="560"
      height="315"
    >
    </iframe>
    <div v-else>No video URL provided.</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  videoUrl: {
    type: String,
    required: true,
  },
});

const embedUrl = computed(() => {
  const url = props.videoUrl;

  switch (true) {
    case !url:
      return '';
    case url.includes('youtube.com') || url.includes('youtu.be'):
      const videoIdYouTube = extractVideoID(url);
      return `https://www.youtube.com/embed/${videoIdYouTube}`;
    case url.includes('vimeo.com'):
      const videoIdVimeo = extractVideoID(url);
      return `https://player.vimeo.com/video/${videoIdVimeo}`;
    default:
      return ''; // If no recognized URL patterns
  }
});

function extractVideoID(url) {
  if (url.includes('youtube.com')) {
    // Extracts ID from URLs like "https://www.youtube.com/watch?v=xxxx"
    return url.split('v=')[1].split('&')[0];
  }
  if (url.includes('youtu.be')) {
    // Extracts ID from URLs like "https://youtu.be/xxxx"
    return url.split('youtu.be/')[1];
  }
  if (url.includes('vimeo.com')) {
    // Extracts ID from URLs like "https://vimeo.com/xxxx"
    return url.split('vimeo.com/')[1];
  }
}
</script>

<style scoped>
.video-player {
  width: 100%; /* Adjust width as necessary */
  height: auto; /* Adjust height as necessary */
}
</style>
